import { useState } from 'react';
import { appAxios } from '@/network/base/appAxios';
import { toast } from 'sonner';
import { useLocation } from 'react-router-dom';

const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="w-5 h-5">
    <path fill="#EA4335" d="M24 9.5c3.14 0 5.95 1.08 8.17 2.86l6.08-6.08C34.46 3.19 29.52 1 24 1 14.82 1 7.07 6.48 3.64 14.22l7.07 5.5C12.43 13.61 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.52 24.5c0-1.64-.15-3.22-.42-4.75H24v9h12.69c-.55 2.98-2.21 5.5-4.72 7.2l7.32 5.69C43.34 37.58 46.52 31.5 46.52 24.5z" />
    <path fill="#FBBC05" d="M10.71 28.28A14.54 14.54 0 0 1 9.5 24c0-1.49.26-2.93.71-4.28l-7.07-5.5A23.94 23.94 0 0 0 0 24c0 3.86.92 7.51 2.55 10.73l8.16-6.45z" />
    <path fill="#34A853" d="M24 47c5.52 0 10.15-1.83 13.53-4.97l-7.32-5.69C28.4 37.82 26.3 38.5 24 38.5c-6.26 0-11.57-4.11-13.29-9.72l-8.16 6.45C6.07 43.52 14.48 47 24 47z" />
  </svg>
);

const AuthPage = () => {
  const location = useLocation();
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const isLimitExceeded = new URLSearchParams(location.search).get('limit_exceeded') === 'true';
  const userInfo = new URLSearchParams(location.search).get('user_info');
  const handleClick = async type => {
    // const { data } = await generateAuthUrl({
    //   type: type,
    //   grantType: 'email-password',
    //   clientId,
    //   clientSecret,
    //   redirectUrl,
    // });  
    const currentParams = new URLSearchParams(location.search);
    const priceId = currentParams.get('price_id');
    const from_zermit = currentParams.get('from_zermit');
    const response = await appAxios.post('/Auth/v1.0/authurl', {
      type: type,
      grantType: 'email-password',
      priceId: priceId,
      from_zermit: from_zermit,
      user_info: encodeURIComponent(JSON.stringify(userInfo)),
    });
    if (response.data.data.success && response.data.data.data?.authUrl) {
      let redirectUrl = "";
      if (response.data.data.from_zermit == "true" && response.data.data.priceId) {
        redirectUrl = `${response.data.data.data?.authUrl}&price_id=${response.data.data.priceId}&from_zermit=true&user_info=${encodeURIComponent(JSON.stringify(userInfo))}`;
      } else {
        redirectUrl = `${response.data.data.data?.authUrl}&user_info=${encodeURIComponent(JSON.stringify(userInfo))}`;
      }
      window.location.href = redirectUrl;
    } else {
      toast.error('Auth Url not received , please try again');
    }
  };

  const handleGoogleAuth = async () => {
    setIsGoogleLoading(true);
    try {
      const currentParams = new URLSearchParams(location.search);
      const priceId = currentParams.get('price_id');
      const from_zermit = currentParams.get('from_zermit');

      const response = await appAxios.post('/Auth/v1.0/authurl', {
        type: 'login',
        grantType: 'google-auth',
        priceId: priceId,
        from_zermit: from_zermit,
      });

      const authUrl = response.data?.data?.data?.authUrl;
      if (authUrl) {
        window.location.href = authUrl;
      } else {
        toast.error('Could not initiate Google sign-in. Please try again.');
      }
    } catch (err) {
      toast.error('Google sign-in failed. Please try again.');
    } finally {
      setIsGoogleLoading(false);
    }
  };

  return (
    <div className="font-baloo-2 flex min-h-screen w-full overflow-hidden">
      {/* ── LEFT PANEL ── */}
      <div
        className="flex flex-1 flex-col px-6 py-8 sm:px-10 sm:py-10 md:px-16"
        style={{ background: 'linear-gradient(360deg, #828fa2 0%, #00233e 100%)' }}
      >
        {/* Brand */}
        <div className="flex-shrink-0 text-base font-bold uppercase tracking-[0.08em] text-white">
          <a href="/">
            <img src="/ZERMIT.png" alt="Zermit" className="max-h-[40px] object-contain" />
          </a>
        </div>

        {/* Form section */}
        <div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col justify-center py-8 sm:py-12">
          <h1
            className="font-baloo-2-600 mb-1 text-[2rem] sm:text-[2.5rem] md:text-[3rem] font-semibold leading-tight text-center"
            style={{ color: '#c89540' }}
          >
            Sign up or Log in
          </h1>
          <p className="font-baloo-400 mb-8 text-[1rem] sm:text-[1.1rem] md:text-[1.25rem] leading-snug text-white w-full text-center">
            Create your account so you can track progress and receive your approved permit here the moment it's issued.
          </p>

          {/* Rate limit banner */}
          {isLimitExceeded && (
            <div className="mb-6 rounded-lg border border-white/20 bg-white/10 px-4 py-3 text-center">
              <p className="text-sm font-medium italic leading-relaxed text-white">
                You have reached your limit. <br /> Please sign up / sign in to continue.
              </p>
            </div>
          )}

          {/* Continue with Google */}
          <button
            onClick={handleGoogleAuth}
            disabled={isGoogleLoading}
            className="font-baloo-2 mb-4 flex w-full cursor-pointer items-center justify-center gap-3 rounded-full bg-white px-4 py-[13px] text-[0.98rem] font-semibold text-[#1a1a1a] shadow-md transition hover:bg-[#f2f2f2] disabled:opacity-70"
          >
            {isGoogleLoading ? (
              <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-gray-700" />
            ) : (
              <GoogleIcon />
            )}
            {isGoogleLoading ? 'Redirecting...' : 'Continue with Google'}
          </button>

          {/* OR divider */}
          <div className="my-1 flex items-center gap-3">
            <div className="h-px flex-1 bg-white/30" />
            <span className="font-baloo-400 text-xs uppercase tracking-widest text-white/70">or</span>
            <div className="h-px flex-1 bg-white/30" />
          </div>

          {/* Sign In */}
          <button
            onClick={() => handleClick('login')}
            className="font-baloo-2 mt-4 w-full cursor-pointer rounded-full bg-white px-4 py-[13px] text-[0.98rem] font-semibold text-[#1a1a1a] shadow-md transition hover:bg-[#f2f2f2]"
          >
            Sign In
          </button>

          {/* Create Account */}
          <button
            onClick={() => handleClick('signup')}
            className="font-baloo-2 mt-3 w-full cursor-pointer rounded-full border border-white/40 bg-transparent px-4 py-[13px] text-[0.98rem] font-semibold text-white shadow-md transition hover:bg-white/10"
          >
            Create Account
          </button>

          {/* Terms */}
          <p className="font-baloo-400 mt-5 text-center text-[0.72rem] leading-relaxed text-white">
            By continuing you agree to our{' '}
            <a href="/terms" className="underline underline-offset-2">
              Terms
            </a>{' '}
            and have read our{' '}
            <a href="/terms" className="underline underline-offset-2">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>

      {/* ── RIGHT PANEL ── */}
      <div className="hidden flex-1 items-stretch  md:flex md:p-8" style={{ background: 'linear-gradient(360deg, #828fa2 0%, #00233e 100%)' }}>
        <div
          className="relative flex flex-1 items-center justify-center rounded-[20px] bg-cover bg-center"
          style={{ backgroundImage: "url('/authscreen.png')" }}
        >
          {/* Chat bubble */}
          <div className="flex w-[85%] max-w-[450px] items-center gap-4 rounded-2xl bg-white px-6 py-5 shadow-2xl">
            <p className="font-baloo-400 m-0 flex-1 text-[1.1rem] font-medium leading-snug text-[#7a8fa6]">
              Submission Without the Friction
            </p>
            <div
              className="flex h-[42px] w-[42px] min-w-[42px] items-center justify-center rounded-full text-white"
              style={{ background: '#c89540' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="19" x2="12" y2="5" />
                <polyline points="5 12 12 5 19 12" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
